var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title_container"},[(this.banner.webDotTitre)?_c('div',{staticClass:"dot_titre"}):_vm._e(),(this.banner.teaser)?_c('h3',{staticClass:"banner__teaser",domProps:{"innerHTML":_vm._s(this.methods.textFormatter(this.banner,this.banner.teaser))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }